"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/objectSpread2.js"));
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _request = _interopRequireDefault(require("@/utils/request"));
// import { getAdvanceParams } from '@/utils/dataGrid'
var _default = exports.default = {
  data: function data() {
    return {
      queryParams: {},
      tableSort: {
        sortOrder: 'desc',
        sortColumn: 'createTime'
      }
    };
  },
  methods: {
    /** 获取 表格数据
     * @description: 获取 表格数据
     * @param { Object } options 请求参数
     * @return { void }
     */
    getDatas: function getDatas(options) {
      var _this = this;
      if (this.dataSource && this.dataSource.url) {
        var _this$$refs$wlDrawer;
        /* 将数据源对象合并覆盖默认配置 */
        var option = this.$$deepMerge({
          data: this.$$deepMerge({
            method: 'POST'
          }, this.tableSort, this.queryParams, (_this$$refs$wlDrawer = this.$refs['wl-drawer-search']) === null || _this$$refs$wlDrawer === void 0 ? void 0 : _this$$refs$wlDrawer.getQueryCondition()),
          params: {}
        });
        [this.dataSource, options].filter(function (datas) {
          return datas;
        }).forEach(function (datas) {
          return ['data', 'params'].filter(function (k) {
            return datas[k];
          }).forEach(function (k) {
            return _this.$$deepMerge(option[k], typeof datas[k] === 'function' ? datas[k](option, _this) : datas[k]);
          });
        });

        /* 加载中不允许重复请求 */
        if (!this.loading.table) {
          var _this$$refs$wlTable;
          // console.log('option', option)
          (_this$$refs$wlTable = this.$refs['wl-table-main']) === null || _this$$refs$wlTable === void 0 || _this$$refs$wlTable.getDatas(option, {
            requestBefore: function requestBefore(a, b) {
              _this.loading.table = true;
              _this.$$listenersEmit('request-before', a, b);
            },
            requestThen: function requestThen(res) {
              _this.$$listenersEmit('request-then', res);
            },
            requestSuccess: function requestSuccess(res) {
              _this.$$listenersEmit('request-success', res);
            },
            requestError: function requestError(err) {
              // 请求失败回调
              _this.$$listenersEmit('request-error', err);
            },
            requestFinally: function requestFinally() {
              // 请求响应完成回调
              _this.$$listenersEmit('request-finally');
            },
            requestOver: function requestOver() {
              setTimeout(function () {
                _this.loading.table = false;
              }, 300);
            }
          });
        }
      } else {
        // eslint-disable-next-line no-console
        if (!this.treeSource.url) console.warn('数据源 dataSource 中没有可获取数据的 api');
      }
    },
    /** 获取 树状图数据
     * @description: 获取 树状图数据
     * @param { Object } options 请求参数
     * @return { void | Promise } 如果有树状图数据源，则返回一个 Promise，如果没有则返回 null
     */
    getTreeDatas: function getTreeDatas(options) {
      var _this2 = this;
      if (this.treeSource && this.treeSource.url) {
        // console.log(this.treeSource)
        var option = (0, _objectSpread2.default)((0, _objectSpread2.default)({
          data: {}
        }, options), this.dataSource);

        /* 加载中不允许重复请求 */
        if (!this.loading.tree) {
          // 继续请求？
          var isTreeContinueToRequest = true;
          var stop = function stop() {
            isTreeContinueToRequest = false;
          };
          // 请求前执行回调，STOP方法执行将阻止请求的继续发生
          this.$$listenersEmit('tree-request-before', option, stop);
          if (isTreeContinueToRequest) {
            this.loading.tree = true;
            return (0, _request.default)(option).then(function (res) {
              // 请求成功回调
              _this2.$$listenersEmit('tree-request-success', res);
              if (res.code === 200) {
                _this2.$$listenersEmit('get-tree-data-then', res);
                // eslint-disable-next-line no-console
                // if (Array.isArray(res.rows)) console.warn('响应返回数据中不包含 rows 参数')
                // this.tableDatas = res.rows

                // const rTable = this.$refs['wl-table-main']
                // if (rTable) {
                //   rTable.setPagination({ total: res.total })
                // }
              }
            }).catch(function (err) {
              // 请求失败回调
              _this2.$$listenersEmit('tree-request-error', err);
              //console.log('getTreeDatas', err)
            }).finally(function () {
              // 请求响应完成回调/*  */
              _this2.$$listenersEmit('tree-request-finally');
              setTimeout(function () {
                _this2.loading.tree = false;
              }, 300);
            });
          }
        }
      }
      return null;
    },
    paginationChange: function paginationChange() {
      this.getDatas();
    }
  }
};